import { computed, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { localStorageSignal } from '../helpers';
import { AuthableRole, BranchRole, SystemRole } from '../types';

@Injectable({
  providedIn: 'root',
})
export class DebugService {
  public isDebugVisible = localStorageSignal<boolean>(false, 'showDebug');

  public readonly canShowDebug = signal<boolean>(!environment.production);

  public roleOverrides = localStorageSignal<Partial<Record<BranchRole | SystemRole, boolean>>>({}, 'debugRoles');
  public hasRoleOverrides = computed(() => Object.values(this.roleOverrides()).filter(Boolean).length > 0);
  public roleOverrideList = computed(() => {
    const overrides = this.roleOverrides();
    return Object.keys(overrides).filter((k) => overrides[k]) as Array<AuthableRole | 'none'>;
  });

  public toggleDebug() {
    this.isDebugVisible.set(!this.isDebugVisible());
  }

  public setRole(role: AuthableRole | 'none', value: boolean): void {
    this.roleOverrides.update((overrides) => ({
      ...overrides,
      [role]: value,
    }));
  }

  public resetRoles() {
    this.roleOverrides.set({});
  }
}
